import React from 'react';
import './LabelValue.scss';

export interface LabelValueProps {
    label?: string;
    value: string | number | undefined;
}

export default function LabelValue(props: LabelValueProps) {
    const { label, value } = props;
    return (
        <div className="LabelValue">
            {label && <div className="label">{label}:</div>}
            <div className="value" title={(value ?? '').toString()}>
                {value}
            </div>
        </div>
    );
}
